import React, { useState } from 'react';
import { MapPin } from 'lucide-react';

/**
 * MapFacade – a nehéz Google Maps iframe helyett alapból egy könnyű placeholder;
 * a valódi iframe CSAK kattintásra töltődik be. Kitölti a szülő konténert
 * (a meglévő `aspect-video` wrapper adja a fix arányt → nincs CLS).
 */
export default function MapFacade({ src, title }) {
  const [show, setShow] = useState(false);

  if (show) {
    return (
      <iframe
        src={src}
        title={title}
        width="100%"
        height="100%"
        style={{ border: 0 }}
        allowFullScreen=""
        loading="lazy"
        referrerPolicy="no-referrer-when-downgrade"
      />
    );
  }

  return (
    <button
      type="button"
      onClick={() => setShow(true)}
      aria-label={`${title} – térkép megjelenítése`}
      className="w-full h-full flex flex-col items-center justify-center gap-2 bg-gray-100 hover:bg-gray-200 transition-colors text-gray-600"
    >
      <MapPin size={28} className="text-brand" />
      <span className="font-semibold text-ink text-sm px-4 text-center">{title}</span>
      <span className="px-4 py-1.5 bg-brand text-white rounded-full text-xs font-semibold">Térkép megjelenítése</span>
    </button>
  );
}
